enum UsersStatic {
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description create user
   */
  UserCreate = "/v2/users/create",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description list user
   */
  UsersList = "/v2/users",

  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description list user
   */
  UserExceptions = "/v2/user-exceptions"
}

const UsersDynamic = {
  /**
   * @member {string}
   * @method put
   * @version 2.0
   * @description create user
   */
  UserUpdate: (id: number) => `/v2/users/${id}?_method=PUT`,
  /**
   * @member {string}
   * @method put
   * @version 2.0
   * @description create user
   */
  UserDetail: (id: number) => `/v2/users/${id}`,

  /**
   * @member {string}
   * @method patch
   * @version 2.0
   * @description enable user
   */
  ActivateUser: (id: number) => `/v2/users/enable/${id}?_method=PUT`,
  /**
   * @member {string}
   * @method patch
   * @version 2.0
   * @description suspend user
   */
  SuspendUser: (id: number) => `/v2/users/suspend/${id}`,
  /**
   * @member {string}
   * @method put
   * @version 2.0
   * @description inactive user
   */
  InactiveUser: (id: number) => `/v2/users/disable/${id}?_method=PUT`,
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description resend user
   */
  resendEmailUser: (id: number) => `/v2/users/${id}/resend-welcome-email`
};

export const UsersEndpoints = {
  ...UsersDynamic,
  ...UsersStatic
};

export type UsersEndpoints = typeof UsersEndpoints;
